import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
class Tabs extends Component {
  render() {
    return (
      <div>
        <section className="section has-text-centered is-section-up">
          <div className="columns is-centered">
            <div className="column is-narrow ">
              <div className="box float-box">
                <div className="tabs is-centered level-item is-large">
                  <ul>
                    <li >
                      <Link to="/faq"  >FAQ</Link>
                    </li>
                    <li>
                      <Link to="/layanan"  >Terms and Condition</Link>
                    </li>
                    <li>
                      <Link to="/privasi"  >Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/kontak" >Kontak</Link>
                    </li>
                  </ul>
                </div>

              </div>
            </div>

          </div>
        </section>
      </div>
    );
  }
}

export default Tabs;
